import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from '@sentry/browser';

import App from "./App";
import "./index.css";

Sentry.init({
  dsn: "https://865a0eb2da774a0b91da36125123a255@sentry.io/1483757",
  environment: (process.env.stage) ? process.env.stage : "develop"
});

const configPromise = fetch('/aws-config.json');

configPromise.then((res) => {
  res.json().then((awsConfig) => {
    //const env = (awsConfig.Stage)
    ReactDOM.render(<App awsConfig={awsConfig} />, document.getElementById("root"));
  });
});
